import React, {Component} from 'react'
import Footer from "./Footer";
import 'react-image-lightbox/style.css';
import Sponsorzy from "./Sponsorzy";
import Organizatorzy from "./Organizatorzy";
import baner from "./assets/pw_data/baner_jasny.png"
import IMAGES from "./assets/data";
import Lightbox from "react-image-lightbox";
import {Link} from "react-router-dom";
import Patronaty from "./Patronaty";

export default class Posters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      photoIndex: 0,
      isOpen: false,
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  render() {
    const {photoIndex, isOpen} = this.state;
    const images = IMAGES.posters
    return (
      <>
        <Baner data={baner}/>
        <section className="bg-gray-200">
          <div className="container max-w-6xl p-6 mx-auto space-y-6 sm:space-y-12">
            <div className="space-y-2 text-center">
              <h2 className="text-3xl font-bold text-greenPW">Wystawa Posterów</h2>
              <h2 className="text-xl  text-greenPW">Wersja on-line wystawy, która zagości do Gmachu Głównego w trzecim
                tygodniu
                (16 -23) stycznia 2023r. Spośród nadesłanych prac wybrane zostaną przez jury konkursowe najlepsze
                postery
                w kategorii indywidualnej i zespołowej.</h2>
              <p className="font-serif text-sm text-greenPW">Kliknij w dowolny poster by zacząć pokaz</p>
            </div>
            <div className="grid justify-center grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {images ? images.slice(0, 3).map((d, i) => (

                <a rel="noopener noreferrer"
                   className="max-w-sm mx-auto group hover:no-underline focus:no-underline bg-bezowyPW"
                   onClick={() => this.setState({isOpen: true})}>
                  <img role="presentation" className="object-cover w-full rounded h-60 "
                       src={d.path}/>
                  <div className="p-6 space-y-2">
                    <h3 className="text-2xl font-semibold group-hover:underline group-focus:underline">{d.title}</h3>
                    <p>{d.name}</p>
                  </div>
                </a>

              )) : 'Loading'}
              {isOpen && (
                <Lightbox
                  mainSrc={images[photoIndex].path}
                  nextSrc={images[(photoIndex + 1) % images.length].path}
                  imageCaption={images[photoIndex].abstract}
                  imageTitle={images[photoIndex].name + " " + images[photoIndex].title}
                  prevSrc={images[(photoIndex + images.length - 1) % images.length].path}
                  onCloseRequest={() => this.setState({isOpen: false})}
                  onMovePrevRequest={() =>
                    this.setState({
                      photoIndex: (photoIndex + images.length - 1) % images.length,
                    })
                  }
                  onMoveNextRequest={() =>
                    this.setState({
                      photoIndex: (photoIndex + 1) % images.length,
                    })
                  }
                />

              )}
            </div>
          </div>
        </section>
        <Nagroda/>
        <WezUdzial/>
        <Patronaty/>
        <Organizatorzy data={this.props.data}/>
        <Sponsorzy data={this.props.data}/>
        <Footer/>
      </>);
  }
}

function Nagroda() {
  return (
    <section className="p-4 lg:p-8 bg-white text-greenPW">

      <div className="container mx-auto space-y-12">
        <div className="flex flex-col overflow-hidden rounded-md shadow-sm lg:flex-row">
          <img
            src="https://www.nature.com/nature-index/article/image/5e3a0294081ed519042c65f5"
            alt="" className="h-80 bg-gray-500 aspect-video"/>
          <div className="flex flex-col justify-center flex-1 p-6 bg-bezowyPW">
            <h3 className="text-3xl font-bold">Każdy z Was może natomiast zagłosować na Nagrodę Publiczności! </h3>
            <p className="my-6 text-greenPW">Głosowanie będzie aktywne do godz. 12.00 21 stycznia 2023r., a ogłoszenie
              wyników nastąpi podczas Kongresu Młodych Naukowców PW, odbywającym się tego samego dnia w Małej Auli
              Gmachu Głównego.
              Zapraszamy do zgłoszeń do konkursu a później do głosowania na Nagrodę Publiczności.
            </p>
            <div
              className="flex flex-col space-y-4 sm:items-center sm:justify-center sm:flex-row sm:space-y-0 sm:space-x-4 lg:justify-start">
              <a rel="noopener noreferrer" href="#"
                 className="px-8 py-3 text-lg font-semibold rounded bg-greenPW text-gray-100 hover:text-orangePW">
                Zagłosuj</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
    ;
}

function WezUdzial() {
  return (
    <div className="bg-gray-800 text-gray-100">
      <div className="px-4 py-16 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl font-extrabold sm:text-4xl">Weź udział w konkursie na Poster Naukowy</h2>
          <p className="mt-4 text-lg text-bezowyPW">Młodzi naukowcy PW! macie możliwość przystąpić do konkursu i
            zaprezentować
            swoje osiągniecia naukowe.
            Najlepsze postery zostaną wystawione na krużgankach Gmachu Głównego PW w dniach 16 – 23 stycznia 2023 r.,
            a laureaci Konkursu otrzymają nagrody rzeczowe.</p>
        </div>
        <dl
          className="mt-12 space-y-10 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-12 lg:grid-cols-4 lg:gap-x-8">
          <div className="flex">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                 aria-hidden="true" className="flex-shrink-0 w-6 h-6 text-violet">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
            </svg>
            <div className="ml-3">
              <dt className="text-lg font-medium">Zgłoszenia przyjmujemy
                <br/>przez MS Forms do końca dnia 08.01.2023.
              </dt>
              <dd className="mt-2 text-bezowyPW">
                <a href="https://forms.office.com/e/7E8RAVD7HU">
                  Zgłoś się
                </a>
              </dd>
            </div>
          </div>
          <div className="flex">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                 aria-hidden="true" className="flex-shrink-0 w-6 h-6 text-violet">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
            </svg>
            <div className="ml-3">
              <dt className="text-lg font-medium">Formatka posterowa dostępna jest pod linkiem</dt>
              <dd className="mt-2 text-bezowyPW">
                <a href="https://tiny.pl/w11v2">
                  Pobierz
                </a>

              </dd>
            </div>
          </div>
          <div className="flex">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                 aria-hidden="true" className="flex-shrink-0 w-6 h-6 text-violet">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
            </svg>
            <div className="ml-3">
              <dt className="text-lg font-medium">Regulamin bieżącej Rundy znajdziecie pod linkiem</dt>
              <dd className="mt-2 text-bezowyPW">
                <a href="https://tiny.pl/w11vt">
                  Regulamin
                </a>
              </dd>
            </div>
          </div>
          <div className="flex">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                 aria-hidden="true" className="flex-shrink-0 w-6 h-6 text-violet">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
            </svg>
            <div className="ml-3">
              <dt className="text-lg font-medium">Jeśli macie dodatkowe pytania, zachęcamy do kontaktu mailowego z
                koordynatorem konkursu
              </dt>
              <dd className="mt-2 text-bezowyPW">
                filip.labaj.dokt@pw.edu.pl
              </dd>
            </div>
          </div>


        </dl>
      </div>
    </div>
  );
}

function Baner() {
  return (
    <section className="bg-gray-800 text-bezowyPW" id="baner">

      <div
        className="container mx-auto flex flex-col items-center px-4 py-16 text-center md:py-32 ">
        <img src={baner} alt="" className="object-contain sm:h-90 lg:h-106 xl:h-122 2xl:h-138"/>
        <div
          className="container mx-auto flex flex-col items-center px-30 py-16 text-center md:py-15 md:px-30 lg:px-30 xl:max-w-5xl">
          <h1 className="text-4xl font-bold leading-none sm:text-5xl">Konkurs i Wystawa Posterów</h1>
          <p className="mt-6 mb-8 text-lg sm:mb-12 text-bezowyPW"> I Gali Młodych Naukowców towarzyszy konkurs na
            poster
            naukowy wraz z
            wystawą najlepszych prac w Gmachu Głównym PW. Wystawa posterów odbędzie się również w formie on-line,
            gdzie będziecie mieć również możliwość zagłosowania na nagrodę publiczności.
            Konkurs ma na celu pokazanie różnorodności badań, jakie prowadzą Młodzi Naukowcy na Politechnice
            Warszawskiej.
          </p>

          <div
            className="flex flex-col space-y-4 sm:items-center sm:justify-center sm:flex-row sm:space-y-0 sm:space-x-4 lg:justify-start">
            <a rel="noopener noreferrer" href="/gmn#pricing"
               className="px-6 py-3 text-lg font-semibold rounded bg-orangePW text-gray-100 hover:text-greenPW">Kup
              Bilet</a>
            <a rel="noopener noreferrer" href={IMAGES.bilety.link_konkurs}
               className="px-7 py-3 text-lg font-semibold rounded bg-orangePW text-gray-100 hover:text-greenPW">Konkurs</a>
          </div>
        </div>
      </div>
    </section>
  );
}
